document.addEventListener('DOMContentLoaded', function () {
  let AUDIO_DURATION_SECONDS = 0;

  let isLoading = false;
  let isPlaying = false;
  let pressStartTime = 0;
  let pausedTime = 0;
  let timeoutId = null;

  const button = document.getElementById('anima-btn');
  const progressBar = document.getElementById('anima-bike');
  const audioPlayer = document.getElementById('audioPlayer');

  function getMaxProgressVW() {
    const MOBILE_BREAKPOINT = 768;
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      return 85;
    } else {
      return 64;
    }
  }

  const MAX_PROGRESS_VW = getMaxProgressVW();
  async function initializeAudio() {
    if (isLoading) return;
    isLoading = true;

    const loadPromise = new Promise((resolve, reject) => {
      audioPlayer.onloadedmetadata = () => {
        resolve();
      };
      audioPlayer.onerror = (e) => {
        reject(new Error('Audio loading failed'));
      };
    });

    try {
      await loadPromise;
      AUDIO_DURATION_SECONDS = audioPlayer.duration;
      if (isNaN(AUDIO_DURATION_SECONDS) || AUDIO_DURATION_SECONDS <= 0) {
        throw new Error('Invalid audio duration obtained.');
      }
    } catch (error) {
      AUDIO_DURATION_SECONDS = 7;
      console.error("Audio initialization failed, using default duration.", error);
    } finally {
      if (AUDIO_DURATION_SECONDS > 0) {
        button.disabled = false;
        button.classList.add('pulse-idle');
        button.classList.add('is-ready');
      } else {
        button.disabled = true;
        console.error("Audio duration could not be determined. Playback disabled.");
      }
      isLoading = false;

      audioPlayer.onended = () => {
        if (isPlaying) {
          stopPlayback({ isAutoStop: true });
        }
      };
    }
  }

  const startPlayback = async (e) => {
    if (e.type.startsWith('touch')) {
      e.preventDefault();
    }
    if (isPlaying || button.disabled) return;

    button.classList.remove('pulse-idle');

    if (pausedTime >= AUDIO_DURATION_SECONDS) {
      pausedTime = 0;
    }

    isPlaying = true;
    const now = Date.now();
    pressStartTime = now;

    audioPlayer.currentTime = pausedTime;
    try {
      await audioPlayer.play();
    } catch (error) {
      isPlaying = false;
      button.classList.add('pulse-idle');
      return;
    }
    const remainingDuration = AUDIO_DURATION_SECONDS - pausedTime;
    const startPositionVW = (pausedTime / AUDIO_DURATION_SECONDS) * MAX_PROGRESS_VW;
    progressBar.style.transitionDuration = '0s';
    progressBar.style.transform = `translateX(${startPositionVW}vw)`;
    setTimeout(() => {
      progressBar.style.transitionDuration = `${remainingDuration}s`;
      progressBar.style.transform = `translateX(${MAX_PROGRESS_VW}vw)`;
    }, 10);
    timeoutId = setTimeout(stopPlayback, remainingDuration * 1000);
  };

  const stopPlayback = (e) => {
    if (e && e.type && e.type.startsWith('touch')) {
      e.preventDefault();
    }

    clearTimeout(timeoutId);
    if (!isPlaying) return;
    audioPlayer.pause();
    pausedTime = audioPlayer.currentTime;
    pausedTime = Math.min(AUDIO_DURATION_SECONDS, pausedTime);
    const currentPositionVW = pausedTime / AUDIO_DURATION_SECONDS * MAX_PROGRESS_VW;
    progressBar.style.transitionDuration = '0s';
    progressBar.style.transform = `translateX(${currentPositionVW}vw)`;
    if (pausedTime >= AUDIO_DURATION_SECONDS) {
      audioPlayer.currentTime = 0;
      pausedTime = 0;
    } else {
    }
    button.classList.add('pulse-idle');
    isPlaying = false;
    pressStartTime = 0;
  };

  button.addEventListener('mousedown', startPlayback);
  button.addEventListener('touchstart', startPlayback);
  button.addEventListener('mouseup', stopPlayback);
  button.addEventListener('touchend', stopPlayback);
  button.addEventListener('touchcancel', stopPlayback);
  button.addEventListener('mouseleave', (e) => {
    if (e.buttons === 1) {
      stopPlayback();
    }
  });

  initializeAudio();
});